export default {
  EDITION_BASIC: 10, // 基础版
  EDITION_PREMIUM: 20, // 高级版
  EDITION_PROFESSIONAL: 30, // 专业版
  EDITION_ULTIMATE: 40, // 旗舰版

  EDITIONS: {
    10: {
      label: '基础版'
    },
    20: {
      label: '高级版'
    },
    30: {
      label: '专业版'
    },
    40: {
      label: '旗舰版'
    }
  }
}
